jQuery(function ($) {
  const $loadMoreObjectsBtn = $('.load-more-objects-button');
  let currentObjectPage = 1;
  const maxObjectPages = parseInt($loadMoreObjectsBtn.data('max-pages'));

  $loadMoreObjectsBtn.on('click', function () {
    if (currentObjectPage >= maxObjectPages) return;

    $loadMoreObjectsBtn.prop('disabled', true).text(ajaxurl.loading);

    const formData = $('.filters-form').serializeArray();
    const requestData = {
      action: 'load_more_objects',
      page: currentObjectPage + 1
    };

    formData.forEach(function (field) {
      requestData[field.name] = field.value;
    });

    $.ajax({
      url: ajaxurl.url,
      type: 'POST',
      data: requestData,
      success: function (response) {
        if (response.success && response.data.html) {
          $('.objects .grid').append(response.data.html);
          currentObjectPage++;

          // Refresh wishlist states
          if (typeof window.refreshButtonStates === 'function') {
            window.refreshButtonStates();
          }

          // Update object links with filter parameters
          const saved = sessionStorage.getItem('objectFilters');
          if (saved) {
            $('.objects .grid .object-item .entry-link').each(function() {
              const $link = $(this);
              const href = $link.attr('href');
              if (href && !href.includes('ref=filtered')) {
                const url = new URL(href, window.location.origin);
                url.searchParams.set('ref', 'filtered');
                $link.attr('href', url.toString());
              }
            });
          }

          // Update .object-number classes and labels
          const coordinatesInput = $('input[name="coordinates"]');
          if (coordinatesInput.length) {
            try {
              const coordsData = JSON.parse(coordinatesInput.val());
              const filteredIDs = Array.isArray(coordsData.filtered)
                ? coordsData.filtered.map(obj => parseInt(obj.id, 10))
                : [];

              const allCoords = Array.isArray(coordsData.all) ? coordsData.all : [];

              allCoords.forEach((obj, index) => {
                const objectId = parseInt(obj.id, 10);
                if (!obj.coordinates || isNaN(objectId)) return;

                const isFiltered = filteredIDs.includes(objectId);
                const $objectEl = $(`#object-${objectId}`);
                const $numEl = $objectEl.find('.object-number');

                if ($numEl.length) {
                  $numEl.text(index + 1);
                  $numEl
                    .removeClass('object-number-white object-number-green')
                    .addClass(isFiltered ? 'object-number-green' : 'object-number-white');
                }
              });
            } catch (e) {
              console.error('Could not parse coordinates JSON after loading more objects.');
            }
          }

          if (currentObjectPage >= maxObjectPages) {
            $loadMoreObjectsBtn.hide();
          } else {
            $loadMoreObjectsBtn.prop('disabled', false).text(ajaxurl.load_more);
          }
        }
      },
      error: function () {
        console.error('Error loading more objects');
        $loadMoreObjectsBtn.prop('disabled', false).text(ajaxurl.load_more);
      }

    });
  });
});
